module.exports = __webpack_public_path__ + "img/lc05.d00bc6a5.png";